import React from 'react';
import PropTypes from "prop-types";
import Figure from './Figure'
import RichPost from 'components/richText';

import {ColumnWrap, RichtextStyle} from './styled'

const ImgWithText = ({el, preview, altText, language }) => {
  const richText = preview ? el.richtext : el.richtext.raw;

  return (
    <ColumnWrap
      wrapText={el.text_overflow == 'wrap' ? true : false}
      leftAlign={el.align_image == 'left' ? true : false}
    >
      <div style={{width:'100%'}}> 
        <Figure 
          dimensions={el.inset_image.dimensions}
          el={el}
          altText={altText}
          wrapText={el.text_overflow == 'wrap' ? true : false}
          leftAlign={el.align_image == 'left' ? true : false}
        />
      
        { richText !== null && (
          <RichtextStyle 
            wrapText={el.text_overflow == 'wrap' ? true : false} 
            leftAlign={el.align_image == 'left' ? true : false}
          >
            <RichPost richContent={richText} language={language} />
          </RichtextStyle>
        )}

      </div>

    </ColumnWrap>
  );
};

ImgWithText.propTypes = {
  altText: PropTypes.string,
  el: PropTypes.object,
  language: PropTypes.string,
  preview: PropTypes.bool
}

export default ImgWithText;